import * as THREE from 'three'
import Experience from '../Experience.js'

export default class Environment {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.debug = this.experience.debug

        //Debug
        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder('Environment').close()
        }

        this.setLight()
        this.setEnvironmentMap()
    }

    setLight () {
        this.light = new THREE.DirectionalLight('#ffffff', 1.5)
        this.light.position.set(.2, 7, 1.2)
        this.light.castShadow = true
        this.light.shadow.camera.far = 25
        this.light.shadow.mapSize.set(2048, 2048)
        this.light.shadow.camera.scale.set(1, 1, 1)
        this.light.shadow.normalBias = .001
        this.scene.add(this.light)

        // Debug
        if (this.debug.active) {
            this.debugFolder.add(this.light, 'intensity').name('lightIntensity').min(0).max(10).step(0.001)

            this.debugFolder.add(this.light.position, 'x').name('lightPosX').min(-10).max(10).step(0.001)
            this.debugFolder.add(this.light.position, 'y').name('lightPosY').min(-10).max(10).step(0.001)
            this.debugFolder.add(this.light.position, 'z').name('lightPosZ').min(-10).max(10).step(0.001)
        }
    }

    setEnvironmentMap () {
        this.environmentMap = {}
        this.environmentMap.intensity = localStorage["theme-preference"] === 'light' ? 1.6 : 1.5
        this.environmentMap.textureLight = this.resources.items.environmentMap
        this.environmentMap.textureDark = this.resources.items.environmentMapDark
        this.environmentMap.textureLight.colorSpace = THREE.SRGBColorSpace
        this.environmentMap.textureDark.colorSpace = THREE.SRGBColorSpace
        this.environmentMap.environment = localStorage["theme-preference"] === 'light' ? this.environmentMap.textureLight : this.environmentMap.textureDark

        this.environmentMap.updateMaterials = () => {
            this.scene.traverse((child) => {
                if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial) {
                    child.material.envMap = this.environmentMap.environment
                    child.material.envMapIntensity = this.environmentMap.intensity
                    child.material.needsUpdate = true

                }
            })
        }
        this.environmentMap.updateMaterials()

        // Debug
        if (this.debug.active) {
            this.debugFolder
                .add(this.environmentMap, 'intensity')
                .name('envMapIntensity')
                .min(0)
                .max(4)
                .step(0.001)
                .onChange(this.environmentMap.updateMaterials)
        }
    }
}